export class UserRole {
  public static ZNIZKA_MARKETINGOWA_NNW_PLUS: UserRole = new UserRole(1339);
  public static ZNIZKA_DEDYKOWANA: UserRole = new UserRole(1338);
  public static ZNIZKA_PRACOWNICZA: UserRole = new UserRole(1182);
  public static ZNIZKA_PRACOWNICZA_WSZYSTKIE_TARYFY: UserRole = new UserRole(1183);
  public static ZNIZKA_SPECJALNA: UserRole = new UserRole(1329);
  public static UMOWA_NA_ODLEGLOSC: UserRole = new UserRole(1193);
  public static KIEROWNIK_CALL_CENTER_PELNOMOCNICTWA: UserRole = new UserRole(1209);
  public static PRACOWNIK_ETATOWY_CALL_CENTER_PELNOMOCNICTWA: UserRole = new UserRole(1208);
  public static EF_KONTAKT_Z_KLIENTEM_POLE_WIDOCZNE: UserRole = new UserRole(1225);
  public static EF_UPRAWNIONA_OWCA_POLE_WIDOCZNE: UserRole = new UserRole(1223);
  public static EF_KIEROWNIK_DZIAL_WZNOWIEN_ZNIZKA_PELNOMOCNICTWA: UserRole = new UserRole(1341);
  public static EF_KIEROWNIK_DZIAL_WZNOWIEN_PELNOMOCNICTWA: UserRole = new UserRole(1255);
  public static EF_KIEROWNIK_REGIONALNY_PELNOMOCNICTWA: UserRole = new UserRole(1187);
  public static EF_KIEROWNIK_REGIONALNY_WZNOWIEN: UserRole = new UserRole(1342);
  public static EF_MENADZER_PELNOMOCNICTWA: UserRole = new UserRole(1186);
  public static EF_KIEROWNIK_PELNOMOCNICTWA: UserRole = new UserRole(1185);
  public static EF_DYREKTOR_PELNOMOCNICTWA: UserRole = new UserRole(1184);
  public static EF_AGENT_PELNOMOCNICTWA: UserRole = new UserRole(1179);
  public static EF_IOR_DLA_AGENTA_PELNOMOCNICTWA: UserRole = new UserRole(1325);
  public static KONCZY_KLIENT: UserRole = new UserRole(1313);
  public static AGENT_SOLID_PELNOMOCNICTWA: UserRole = new UserRole(1256);
  public static KIEROWNIK_SOLID_PELNOMOCNICTWA: UserRole = new UserRole(1285);
  public static DUR_PRACOWNIK_KOMUNIKACJA_1: UserRole = new UserRole(1409);
  public static DUR_PRACOWNIK_OSOBOWE_PELNOMOCNICTWA: UserRole = new UserRole(1379);
  public static DUR_PRACOWNIK_MAJATEK_2: UserRole = new UserRole(1378);
  public static DUR_PRACOWNIK_MAJATEK_1: UserRole = new UserRole(1377);
  public static DUR_PRACOWNIK_SPEC_PELNOMOCNICTWA: UserRole = new UserRole(1353);
  public static DUR_DYREKTOR_PELNOMOCNICTWA: UserRole = new UserRole(128);
  public static DUR_PRACOWNIK_PELNOMOCNICTWA: UserRole = new UserRole(127);
  public static DYREKTOR_EF_ELM_PELNOMOCNICTWA_2: UserRole = new UserRole(1358);
  public static DYREKTOR_REGIONALNY_FLOTY_PELNOMOCNICTWA: UserRole = new UserRole(1307);
  public static DYREKTOR_ODDZIALU_FLOTY_DSA_PELNOMOCNICTA: UserRole = new UserRole(1400);

  public static fromCode(code?: number): UserRole | undefined {
    for (const e of Object.values(UserRole)) {
      if (e.code === code) {
        return e;
      }
    }
    return undefined;
  }

  public readonly code: number;

  private constructor(code: number) {
    this.code = code;
  }

  public static isDistancePolicyRole(roles: UserRole[] | undefined) {
    const distancePolicyRoles = [UserRole.UMOWA_NA_ODLEGLOSC, UserRole.KIEROWNIK_CALL_CENTER_PELNOMOCNICTWA, UserRole.PRACOWNIK_ETATOWY_CALL_CENTER_PELNOMOCNICTWA];
    return distancePolicyRoles.some(role => roles?.includes(role));
  }

  public static isDistancePolicyRequiredRole(roles: UserRole[] | undefined) {
    const distancePolicyRequiredRoles = [UserRole.KIEROWNIK_CALL_CENTER_PELNOMOCNICTWA, UserRole.PRACOWNIK_ETATOWY_CALL_CENTER_PELNOMOCNICTWA];
    return distancePolicyRequiredRoles.some(role => roles?.includes(role));
  }

  public static isEurofinanceRole(roles: UserRole[] | undefined) {
    const eurofinanceAgentRoles = [
      UserRole.EF_KONTAKT_Z_KLIENTEM_POLE_WIDOCZNE,
      UserRole.EF_UPRAWNIONA_OWCA_POLE_WIDOCZNE,
      UserRole.EF_KIEROWNIK_DZIAL_WZNOWIEN_ZNIZKA_PELNOMOCNICTWA,
      UserRole.EF_KIEROWNIK_DZIAL_WZNOWIEN_PELNOMOCNICTWA,
      UserRole.EF_KIEROWNIK_REGIONALNY_PELNOMOCNICTWA,
      UserRole.EF_KIEROWNIK_REGIONALNY_WZNOWIEN,
      UserRole.EF_MENADZER_PELNOMOCNICTWA,
      UserRole.EF_KIEROWNIK_PELNOMOCNICTWA,
      UserRole.EF_DYREKTOR_PELNOMOCNICTWA,
      UserRole.EF_AGENT_PELNOMOCNICTWA,
      UserRole.EF_IOR_DLA_AGENTA_PELNOMOCNICTWA
    ];
    return eurofinanceAgentRoles.some(role => roles?.includes(role));
  }

  public static isSolidRole(roles: UserRole[] | undefined) {
    const solidAgentsRoles: UserRole[] = [
      UserRole.AGENT_SOLID_PELNOMOCNICTWA,
      UserRole.KIEROWNIK_SOLID_PELNOMOCNICTWA
    ];
    return solidAgentsRoles.some(role => roles?.includes(role));
  }

  public static isDurRole(roles: UserRole[] | undefined) {
    const durAgentRoles: UserRole[] = [
      UserRole.DUR_PRACOWNIK_KOMUNIKACJA_1,
      UserRole.DUR_PRACOWNIK_OSOBOWE_PELNOMOCNICTWA,
      UserRole.DUR_PRACOWNIK_MAJATEK_2,
      UserRole.DUR_PRACOWNIK_MAJATEK_1,
      UserRole.DUR_PRACOWNIK_SPEC_PELNOMOCNICTWA,
      UserRole.DUR_DYREKTOR_PELNOMOCNICTWA,
      UserRole.DUR_PRACOWNIK_PELNOMOCNICTWA,
      UserRole.DYREKTOR_EF_ELM_PELNOMOCNICTWA_2,
      UserRole.DYREKTOR_REGIONALNY_FLOTY_PELNOMOCNICTWA,
      UserRole.EF_KIEROWNIK_REGIONALNY_PELNOMOCNICTWA,
      UserRole.DYREKTOR_ODDZIALU_FLOTY_DSA_PELNOMOCNICTA
    ];
    return durAgentRoles.some(role => roles?.includes(role));
  }
}
